import styled from "styled-components";

export const BaseMenu = styled.div`
background-color: black;
display: flex;
justify-content: center;
padding: 5px;
box-shadow: 0px 1px 1px 1px #2e2e2e4f;

`

export const MenuStyle = styled.div`
border: solid;
background-color: black;

h1{
    color: red;
}

span{
    color: #e1ff00;
}



`